import { api, method } from '../api/apiClient';

export const create = async (payload) => {
    try {
        return await api(method.POST, '/hotel', payload);
    } catch (error) {
        console.error(`Error while creating hotel ${error}`);
        throw error;
    }
};

export const fetch = async ({
    skip = 0,
    limit = 10,
    sortKey = '',
    sortOrder = '',
    filterKey = '',
    filterValue = ''
}) => {
    try {
        const query = `skip=${skip}&limit=${limit}&sortKey=${sortKey}&sortOrder=${sortOrder}&filterKey=${filterKey}&filterValue=${filterValue}`;
        return await api(method.GET, `/hotel?${query}`);
    } catch (error) {
        console.error(`Error while fetching hotel ${error}`);
        throw error;
    }
};

export const remove = async (id) => {
    try {
        return await api(method.DELETE, `/hotel/${id}`);
    } catch (error) {
        console.error(`Error while removing hotel ${error}`);
        throw error;
    }
};

export const update = async (payload) => {
    try {
        const { id, data } = payload;
        return await api(method.PUT, `/hotel/${id}`, data);
    } catch (error) {
        console.error(`Error while updating hotel ${error}`);
        throw error;
    }
};

export const dashboard = async (hotelId) => {
    try {
        return await api(method.GET, `/hotel/dashboard/${hotelId}`);
    } catch (error) {
        console.error(`Error fetching dashboard data ${error}`);
        throw error;
    }
};
